export const BUILDER_NODE_ID = 'mail-builder';
